<template>
  <div class="displayPage">
        <div class="icon iconfont icon-icon-test"></div>
  </div>
</template>
<script>

export default {
  data () {
    return {

    }
  }
  
}
</script>

<style scoped lang="less">
  .displayPage{
     min-height: 100%;
    display:  flex;
    align-items: center;
    justify-content: center;

    .icon{
       font-size: 50px;
       width: 50px;
       height: 50px;
       display: flex;
      align-items: center;justify-content: center;
    }

  }
</style>
